import { render, staticRenderFns } from "./gerenciadorAnexos.vue?vue&type=template&id=61eacddb&scoped=true"
import script from "./gerenciadorAnexos.vue?vue&type=script&lang=js"
export * from "./gerenciadorAnexos.vue?vue&type=script&lang=js"
import style0 from "./gerenciadorAnexos.vue?vue&type=style&index=0&id=61eacddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eacddb",
  null
  
)

export default component.exports